import {
  BankAccountResourceModel,
  BankAccountType,
  BankAccountWithdrawPeriod,
  BankNames
} from '@/modules/bank-account/models/bank-account-resource.model'
import { BillingInfoResourceModel, BillingInfoType } from '@/modules/billing-info/models/billing-info-resource'
import { Data } from '@/modules/shared/models/data'
import { RoleCollectionModel } from '@/modules/role/models/role-collection.model'
import { PermissionCollectionModel } from '@/modules/permission/models/permission-collection.model'
import { PersonTitle } from '@/modules/common/person/models/PersonResource.model'

export enum UserType {
  'ADMIN' = 'admin',
  'PANEL' = 'panel',
  'WRITER' = 'writer',
}

export interface BasicUserResourceModel {
  id: number
  username: string
  displayname?: string
  avatar: string
  phone?: string
  email?: string
}

export interface UserViewResourceModel {
  id: number
  username: string
  displayname?: string
  avatar: string
  phone?: string
}

export interface UserInfoComponentResourceModel {
  id: number
  username: string,
  displayname: string,
  avatar: string,
  email: string,
  email_verified_at: string | null
  phone: string,
  phone_verified_at: string | null
  wallet_amount: number
  writer_wallet_amount: number
  word_rate: number | null
  chat_id: number | null,
  permissions: PermissionCollectionModel[]
  roles: RoleCollectionModel[]
  bank_account: BankAccountResourceModel
  billing_info: BillingInfoResourceModel
  created_at: string,
  wallet
  writer_wallet
  edit_url
  vip_group
  verify
  switch_url
}

export interface UserResourceInAdminModel {
  id: number
  username: string,
  displayname: string,
  avatar: string,
  email: string,
  email_verified_at: string | null
  phone: string,
  phone_verified_at: string | null
  wallet_amount: number
  writer_wallet_amount: number
  word_rate: number | null
  chat_id: number | null,
  permissions: PermissionCollectionModel[]
  roles: RoleCollectionModel[]
  bank_account: BankAccountResourceModel
  billing_info: BillingInfoResourceModel
  created_at: string,
  last_login_at: string
}

export interface UserResourceWithInModelAdmin {
  bank_account: {
    types: { [key in BankAccountType]: string },
    bank_names: { [key in BankNames]: string },
    bank_account_withdraw_periods: { [key in BankAccountWithdrawPeriod]: string }
  }
  billing_info: {
    types: { [key in BillingInfoType]: string }
  }
  permissions: PermissionCollectionModel[]
}

export interface UserBootDataResourceModel {
  id: number
  avatar: string
  bot_activation: Record<PersonTitle, string>
  display_name: string
  username: string,
  created_at: string,
  roles: string[]
}

export interface UserBootDataResourceModelInAdmin extends UserBootDataResourceModel {
  permissions: string[]
}

export interface UserBootModel {
  base_path: string,
  base_url: string
  user: UserBootDataResourceModelInAdmin
}

export interface UserProfileModel {
  username: string,
  displayname: string,
  email: string,
  phone: string,
  verified: boolean
}

export interface UserProfileInfoResourceModel {
  username: string
  displayname: string
  email: string
  phone: string
  telegram_bot_activation: string
  verified: UserProfileVerifyKeysModel
  notifications: UserProfileNotificationsKeysModel
}

export interface UserProfileVerifyKeysModel {
  email_notice: boolean
  sms_notice: boolean
  telegram_notice: boolean
}

export interface UserProfileNotificationsKeysModel {
  email_notice: boolean
  sms_notice: boolean
  telegram_notice: boolean
}


export type UserProfileInfoResourceType = Data<UserProfileInfoResourceModel>

export type UserResourceInAdminType = Data<UserResourceInAdminModel> & UserResourceWithInModelAdmin
